import { LockingSystemComponentType } from "@secureo/common/typings/LockingSystem"

const attributeName = "lockingSystemComponentType"

export const getWhereConditionForLockingSystemComponentTypeIn = (
	isIn: LockingSystemComponentType[],
) => {
	const keyValue = isIn
		.map((lockingSystemComponentType) => `\\"${lockingSystemComponentType}\\"`)
		.join(", ")

	const isInAttribute = `masterData(current(masterVariant(attributes(name=\\"${attributeName}\\" and value(key in (${keyValue}))))))`

	return isInAttribute
}
